import React from 'react';

const sections = [
  {
    title: "Ecosistema Digital",
    links: [
      { name: "Tienda Virtual", url: "https://tienda.sistemaspro.info", icon: "🛒", desc: "Infraestructura eCommerce de alto rendimiento." },
      { name: "Portal de Publicaciones", url: "https://publicaciones.sistemaspro.info", icon: "📰", desc: "Gestión centralizada de contenidos digitales." },
      { name: "Gestión Administrativa", url: "https://ylse.gonzalez.sistemaspro.info", icon: "💼", desc: "Panel ejecutivo para control de operaciones." }
    ]
  },
  {
    title: "Sistemas Core",
    links: [
      { name: "Real Estate SaaS", url: "/realestate", icon: "🏠", desc: "Solución integral para el sector inmobiliario." },
      { name: "Portafolio Pro", url: "/portafolio", icon: "🚀", desc: "Galería de desarrollos y casos de éxito." },
      { name: "Acceso Sistemas", url: "/servicios", icon: "🔐", desc: "Entrada a la suite de aplicaciones ProCore.", primary: true }
    ]
  }
];

function App() {
  return (
    <div className="min-h-screen bg-[#f8fafc] font-sans text-slate-900">
      
      {/* NAVBAR PROFESIONAL: LOGO INTEGRADO */}
      <nav className="fixed top-0 w-full z-50 bg-[#0f172a] border-b border-blue-500/20 shadow-2xl">
        <div className="max-w-6xl mx-auto px-6 h-24 flex items-center justify-between">
          <div className="flex items-center group">
            <div className="bg-white/5 p-3 rounded-2xl border border-white/10 group-hover:border-blue-500/50 transition-all duration-500">
              <img src="/img/logo.png" alt="SistemasPro" className="h-10 md:h-12 w-auto brightness-200" />
            </div>
            <div className="ml-5 hidden md:block">
              <p className="text-[10px] font-black tracking-[0.4em] text-blue-500 leading-none mb-1 uppercase">Sistemas Pro</p>
              <p className="text-sm font-bold text-white tracking-tighter italic">High-End Solutions</p>
            </div>
          </div>
          
          <div className="flex items-center gap-6">
            <a href="/servicios" className="relative px-6 py-3 bg-blue-600 text-white text-[11px] font-black tracking-[0.2em] rounded-xl hover:bg-blue-500 transition-all shadow-lg shadow-blue-500/40 uppercase">
              Plataforma
            </a>
          </div>
        </div>
      </nav>

      {/* HERO SECTION */}
      <header className="relative pt-48 pb-28 px-6 bg-[#0f172a] overflow-hidden">
        <img 
          src="/img/banner.png" 
          alt="Banner" 
          className="absolute inset-0 w-full h-full object-cover opacity-20 mix-blend-overlay"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-[#0f172a]/80 to-[#0f172a]"></div>
        
        <div className="relative z-10 max-w-6xl mx-auto">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-blue-500/10 border border-blue-500/20 mb-8">
            <span className="w-2 h-2 rounded-full bg-blue-500 animate-pulse"></span>
            <span className="text-blue-400 text-[10px] font-black tracking-widest uppercase">Arquitectura de Código Premium</span>
          </div>
          <h1 className="text-6xl md:text-8xl font-black text-white tracking-tighter leading-none mb-8">
            SISTEMAS<br/><span className="text-blue-500">PRO</span>
          </h1>
          <p className="text-xl md:text-2xl text-slate-400 font-light max-w-2xl leading-relaxed border-l-2 border-blue-500/30 pl-8">
            Desarrollamos la ingeniería detrás de los negocios más ambiciosos. <span className="text-white font-bold">Precisión, seguridad y escalabilidad</span> desde 2008.
          </p>
        </div>
      </header>

      {/* CUERPO CENTRAL */}
      <main className="max-w-6xl mx-auto px-6 py-24">
        {sections.map((section, idx) => (
          <div key={idx} className="mb-24 last:mb-0">
            <div className="flex items-center gap-4 mb-12">
              <h2 className="text-3xl font-black text-slate-800 tracking-tight">{section.title}</h2>
              <div className="h-1.5 w-16 bg-blue-600 rounded-full"></div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
              {section.links.map((link, lIdx) => (
                <a 
                  key={lIdx} 
                  href={link.url} 
                  className={`group p-10 rounded-[2.5rem] border-2 transition-all duration-500 hover:-translate-y-4 ${
                    link.primary 
                    ? 'bg-[#1e293b] border-[#1e293b] text-white shadow-2xl shadow-blue-900/30' 
                    : 'bg-white border-transparent hover:border-blue-500 shadow-xl shadow-slate-200/50 hover:shadow-2xl'
                  }`}
                >
                  <div className={`w-16 h-16 rounded-2xl flex items-center justify-center mb-8 text-4xl shadow-inner ${
                    link.primary ? 'bg-blue-600 text-white' : 'bg-slate-50 text-slate-700 group-hover:bg-blue-600 group-hover:text-white'
                  } transition-colors duration-500`}>
                    {link.icon}
                  </div>
                  <h3 className="text-2xl font-black mb-4 tracking-tight uppercase leading-none">{link.name}</h3>
                  <p className={`text-sm leading-relaxed mb-10 font-medium ${
                    link.primary ? 'text-slate-400' : 'text-slate-500'
                  }`}>
                    {link.desc}
                  </p>
                  <div className={`text-[10px] font-black tracking-[0.2em] transition-all ${
                    link.primary ? 'text-blue-400' : 'text-blue-600 opacity-0 group-hover:opacity-100 group-hover:translate-x-3'
                  }`}>
                    ACCEDER AHORA →
                  </div>
                </a>
              ))}
            </div>
          </div>
        ))}
      </main>

      {/* FOOTER */}
      <footer className="bg-[#0f172a] pt-24 pb-12 px-6 border-t border-white/5">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-16 mb-20 text-left">
          <div className="col-span-1">
            <div className="bg-white/5 p-4 rounded-2xl w-fit mb-8 border border-white/10">
              <img src="/img/logo.png" alt="SistemasPro" className="h-10 brightness-200" />
            </div>
            <p className="text-slate-400 text-sm leading-relaxed font-medium">
              Especialistas en arquitectura de software y despliegue de soluciones empresariales. 18 años garantizando calidad y precisión digital.
            </p>
          </div>
          
          <div>
            <h4 className="text-white text-[11px] font-black tracking-[0.3em] uppercase mb-10">Explorar</h4>
            <ul className="space-y-4 text-slate-400 text-sm font-bold">
              <li><a href="/" className="hover:text-blue-500 transition-colors">Inicio</a></li>
              <li><a href="/servicios" className="hover:text-blue-500 transition-colors">Servicios SaaS</a></li>
              <li><a href="/portafolio" className="hover:text-blue-500 transition-colors">Casos de Éxito</a></li>
            </ul>
          </div>

          <div className="bg-white/5 p-8 rounded-[2rem] border border-white/10">
            <h4 className="text-white text-[11px] font-black tracking-[0.3em] uppercase mb-6">Status Global</h4>
            <div className="flex items-center gap-4 mb-4">
              <div className="w-3 h-3 bg-green-500 rounded-full shadow-[0_0_15px_rgba(34,197,94,0.6)] animate-pulse"></div>
              <p className="text-white text-sm font-bold tracking-tight">Servidores Activos</p>
            </div>
            <p className="text-slate-500 text-[11px] font-medium italic">Sistemas operando al 99.9% de uptime.</p>
          </div>
        </div>

        <div className="max-w-6xl mx-auto pt-12 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-8">
          <p className="text-[10px] font-black tracking-[0.4em] text-slate-600 uppercase">
            © 2008 - 2026 SISTEMASPRO.INFO | VENEZUELA - GLOBAL
          </p>
          <div className="flex gap-4">
             <span className="px-3 py-1 bg-white/5 rounded text-[9px] font-black text-slate-500 tracking-widest border border-white/5">SSL SECURE</span>
             <span className="px-3 py-1 bg-white/5 rounded text-[9px] font-black text-slate-500 tracking-widest border border-white/5">PHP 8.x</span>
          </div>
        </div>
      </footer>

      {/* WHATSAPP FLOTANTE CORREGIDO */}
      <a 
        href="https://wa.me/584244369311" 
        className="fixed bottom-10 right-10 w-16 h-16 bg-[#25D366] rounded-2xl shadow-2xl flex items-center justify-center hover:scale-110 active:scale-95 transition-all z-50 group"
      >
        <img src="/img/icono_whatsapp.png" alt="WA" className="w-8 h-8" />
        <span className="absolute right-full mr-4 bg-white px-5 py-2 rounded-xl text-[10px] font-black tracking-widest shadow-2xl opacity-0 group-hover:opacity-100 transition-all whitespace-nowrap text-[#0f172a] uppercase border border-slate-100">
          Soporte Online
        </span>
      </a>
    </div>
  );
}

export default App;